/**
 * Brand logos for the Apple / Google / VK ID auth buttons.
 * Shared between LoginForm and RegisterForm.
 */

export function AppleLogoIcon() {
  return (
    <svg className="size-5" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
    </svg>
  );
}

export function GoogleLogoIcon() {
  return (
    <svg
      className="size-5"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  );
}

/** White VK ID mark (same vector as Android `ic_vk_id_white`). */
export function VkIdLogoIcon() {
  return (
    <svg
      className="size-5"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M4.265 4.265C3 5.531 3 7.567 3 11.64V12.36C3 16.433 3 18.469 4.265 19.735C5.531 21 7.567 21 11.64 21H12.36C16.433 21 18.469 21 19.735 19.735C21 18.469 21 16.433 21 12.36V11.64C21 7.567 21 5.531 19.735 4.265C18.469 3 16.433 3 12.36 3H11.64C7.567 3 5.531 3 4.265 4.265Z"
        fill="#FFFFFF"
      />
      <path
        d="M12.609 16C8.556 16 6.096 13.182 6 8.5H8.053C8.117 11.939 9.679 13.397 10.876 13.697V8.5H12.844V11.468C13.999 11.34 15.208 9.99 15.614 8.5H17.551C17.241 10.332 15.925 11.682 14.995 12.239C15.925 12.689 17.423 13.868 18 16H15.871C15.422 14.575 14.321 13.471 12.845 13.321V16H12.609Z"
        fill="#0077FF"
      />
    </svg>
  );
}
